import { atom, useAtom } from 'jotai';
import { useEffect } from 'react';

const focusAtom = atom(false);

export function useFocusMode() {
  const [focus, setFocus] = useAtom(focusAtom);
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName;
      const typing = tag === 'INPUT' || tag === 'TEXTAREA' || (e.target as HTMLElement)?.isContentEditable;
      if ((e.key === 'f' || e.key === 'F') && !typing && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault();
        setFocus((v) => !v);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [setFocus]);
  return { focus, setFocus, toggle: () => setFocus((v) => !v) };
}
